import React from 'react';
import { Card } from '@/components/ui/card';

interface EmptyStateProps {
  title: string;
  description: string;
  icon?: React.ReactNode;
  action?: React.ReactNode;
}

export const EmptyState: React.FC<EmptyStateProps> = ({ title, description, icon, action }) => {
  return (
    <Card className="p-8">
      <div className="text-center space-y-4">
        {icon && (
          <div className="w-16 h-16 mx-auto bg-muted rounded-full flex items-center justify-center">
            {icon}
          </div>
        )}
        <h3 className="text-lg font-semibold">{title}</h3>
        <p className="text-muted-foreground max-w-md mx-auto">{description}</p>
        {action && <div className="pt-2">{action}</div>}
      </div>
    </Card>
  );
};